import { toast } from '@shared/lib'

export function setCSRFToken(axiosInstance) {
  axiosInstance.interceptors.request.use(function(config) {
    const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute('content')

    config.headers['X-CSRF-TOKEN'] = authenticityToken
    config.headers['CurrentLocation'] = window.location.href
    config.headers['APP'] = 'Vue'

    return config
  })
}

export function checkResponseStatus(axiosInstance) {
  axiosInstance.interceptors.response.use(
    function(response) {
      return response
    },
    function(error) {
      const response = error.response

      if (response.status === 403 || response.status === 404) {
        window.location.hash = '#/'
      } else if (response.status === 429) {
        return { data: null }
      } else if (response.status === 401) {
        toast.error({
          title: 'Возникла ошибка',
          text: response.data?.alert || 'Сессия истекла'
        })

        setTimeout(() => {
          window.location.href = response.data?.url || '/login'
        }, 2500)
      }

      return Promise.reject(error)
    }
  )
}